import { useState } from 'react';
import { SelectOption } from '../searchableSelect/searchableSelectTypes';
import { useConflictCheck } from '../../context/ConflictCheckContext';
import { useFetchUsers } from '../../hooks/useFetchUsers';
import { IConflictCheckParams } from '../../interface/conflictCheck';
import { IUser } from '../../interface/user';

/** The props `SearchableSelect` needs to pick who processed a conflict check, from the same list the picker screen uses. */
export const useProcessedBySelect = () => {
  const { conflictCheckParams, updateConflictCheckParams } = useConflictCheck();
  const [searchValue, setSearchValue] = useState('');
  const {
    data: users,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useFetchUsers({
    pageSize: 20,
    sortBy: ['firstNames:ASC'],
    search: searchValue,
  });

  const options: SelectOption[] = users.map((user: IUser) => ({
    value: user.id,
    label: user.fullName,
  }));

  const value: SelectOption | null = conflictCheckParams?.checkedByUserId
    ? {
        value: conflictCheckParams.checkedByUserId,
        label: conflictCheckParams.checkedByUserName ?? '',
      }
    : null;

  const onChange = (option: SelectOption) => {
    const user = users.find(({ id }: IUser) => id === option.value);
    if (!user) return;
    updateConflictCheckParams({
      ...conflictCheckParams,
      checkedByUserId: user.id,
      checkedByUserName: user.fullName,
    } as IConflictCheckParams);
  };

  return {
    options,
    value,
    onChange,
    onSearch: setSearchValue,
    onLoadMore: fetchNextPage,
    hasMore: Boolean(hasNextPage),
    loading: isLoading,
    loadingMore: isFetchingNextPage,
  };
};
